import React,{useState} from 'react';
import { Media } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import Avatar from '@mui/material/Avatar'
import { stringAvatar } from 'utility/common.util'
import fallbackImage from 'assets/images/user/doctor-male-64.png'
import { useTimeFormat } from 'contexts/TimeFormatContext';
const images = require.context('../../../../../../../assets/images/user', true);

const Friend = ({ data, activeId, clicked }) => {
    const [hasError,setHasError] = useState(false)
    const {formatDateTime} = useTimeFormat()
    let photo = images(`./${data.photo}`);
    photo = data?.photoUrl ? {default:data.photoUrl} : photo
    let timeClass = ['d-block'];
    if (data.status) {
        timeClass = [...timeClass, 'text-c-green'];
    } else {
        timeClass = [...timeClass, 'text-muted'];
    }

    let time = '';
    if (data.time) {
        time = <small className={timeClass.join(' ')}>{formatDateTime(data.time)}</small>;
    }

    let newFriend = '';
    if (data.new) {
        newFriend = <div className="live-status">{data.new}</div>;
    }

    return (
        <React.Fragment>
            <Media className={activeId === data.id ? 'userlist-box active' : 'userlist-box'} onClick={clicked}>
                <Link to='#' className="media-left"> 
                    {!hasError && data.photoUrl ? (<div class='avatar-crop-container'><img className="media-object img-radius" 
                    src={photo.default} alt={data.name}
                    onError={(e)=> {e.target.onerror=null; setHasError(true)}}
                    /></div>):
                    (<Avatar {...stringAvatar(data.name)} className="avatar" />)}
                    {newFriend}
                    </Link>
                <Media.Body>
                    <h6 className="chat-header">{data.name}{time}</h6>
                </Media.Body>
            </Media>
        </React.Fragment>
    );
};

export default Friend;
